// Appends the current page as ?redirect= to auth links marked with
// data-redirect-here, so a visitor returns to where they were after logging in.
//
// Done in the browser because these links live inside a {{ nocache }} region.
// With full static caching that region is rendered through a POST to
// /!/nocache, where a server-side `current_uri` resolves to that endpoint
// instead of the page the visitor is on.
export default function initRedirectHere() {
    const apply = () => {
        const here = window.location.pathname + window.location.search;

        document.querySelectorAll('a[data-redirect-here]').forEach((link) => {
            const url = new URL(link.getAttribute('href'), window.location.origin);
            url.searchParams.set('redirect', here);
            link.setAttribute('href', url.pathname + url.search);
            link.removeAttribute('data-redirect-here');
        });
    };

    apply();

    // The nocache regions arrive after the page has loaded, so the links this
    // targets may not exist yet on first run.
    document.addEventListener('statamic:nocache.replaced', apply);
}
